enum ShopkeeperStatus {
	NotShopkeeper = 0,
	WaitingForActivation = 1,
	IsShopkeeper = 2
}

export default ShopkeeperStatus;
